<template>
  <div class="">
    <reports-permissions> </reports-permissions>
  </div>
</template>

<script>
import ReportsPermissions from "@/components/profile/permissions/reports/index.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    ReportsPermissions,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: `Modifica Permessi Report :: ${this.$route.params.user.username}`,
        path: "reports.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
    } else {
      this.notifyQueue({
        text: `Modifica Permessi Report :: ${this.$route.params.user.username}`,
        path: "reports.edit",
        level: 3,
      });
    }
  },
};
</script>
